import { CommunityUser } from './community-user.model';
import { UserConstraints } from './user-constraints.model';
import { UserGroupDTO } from '@sb-tools/typescript/models/dto/user-group.dto';

export class CommunityUserExtended extends CommunityUser {
    communityCount: number;
    constraints: UserConstraints;
    groups: UserGroupDTO[];
    hasHelperCategories: boolean;
    // todo: recheck all this properties, parent model has some of them
    hasAccessToAgentData: boolean; // only GUI property
    hasAccessToAttachments: boolean; // only GUI property
    hasAccessToInlineImages: boolean; // only GUI property
    hasAccessToNotes: boolean; // only GUI property
    hasAccessToTicketLog: boolean; // only GUI property
    isReadOnly: boolean; // only GUI property
}
